import { Stack, styled } from '@mui/material';

export const SummaryContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '1rem',
  width: '100%',
  padding: '0 0.25rem',
}));

export const TitleColumn = styled(Stack)(() => ({
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1rem',
}));

export const Eyebrow = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: '100%',
  letterSpacing: '0.24px',
  textTransform: 'uppercase',
  color: theme.palette.accent.main,
}));

export const TitleId = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'baseline',
  gap: '0.75rem',
}));

export const Title = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '2.5rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.grey[950],
}));

export const SupportId = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.grey[900],
}));

export const SubtitleRow = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.grey[900],
}));

export const ServicesLabel = styled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '1rem',
  fontWeight: 500,
  lineHeight: '100%',
  color: theme.palette.grey[900],
}));

export const ServicesColumn = styled(Stack)(() => ({
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  gap: '0.625rem',
}));

export const ServicesRow = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.625rem',
}));

export const ServiceIconBadge = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.25rem',
  borderRadius: '0.5rem',
  backgroundColor: active ? theme.palette.accent.main : theme.palette.grey[200],
  color: active ? theme.palette.common.white : theme.palette.grey[500],
}));

export const TagsRow = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: '0.5rem',
}));

export const StatusChip = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem 1rem',
  borderRadius: '1rem',
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: '#FEFEFE',
  fontSize: '0.75rem',
  fontWeight: 500,
  color: theme.palette.grey[600],
  whiteSpace: 'nowrap',
}));

export const StatusChipDot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  width: 6,
  height: 6,
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: active ? theme.palette.green[500] : theme.palette.grey[400],
}));
